import { render, staticRenderFns } from "./application-changelog.vue?vue&type=template&id=48a665f2&scoped=true"
import script from "./application-changelog.vue?vue&type=script&lang=ts"
export * from "./application-changelog.vue?vue&type=script&lang=ts"
import style0 from "./application-changelog.vue?vue&type=style&index=0&id=48a665f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a665f2",
  null
  
)

export default component.exports